import React, { useState, useEffect } from "react";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { DataTypeProvider } from "@devexpress/dx-react-grid";
import { http } from "../../services/http";

const ConveniosEditor = ({ value, onValueChange, disabled }) => {
  const [options, setOptions] = useState([]);

  function getConvenios() {
    http.get("convenios").then((response) => {
      setOptions(response?.data);
    });
  }

  useEffect(() => {
    getConvenios();
  }, []);

  if (disabled) {
    return value;
  }

  return (
    <Select input={<Input />} value={value} onChange={(event) => onValueChange(event.target.value)} style={{ width: "95%" }}>
      <MenuItem value="">Todos</MenuItem>
      {options?.map((item) => {
        return (
          <MenuItem key={item.convenio} value={item.convenio}>
            {item.convenio ?? item.convenio}
          </MenuItem>
        );
      })}
    </Select>
  );
};
export const ConveniosTypeProvider = (props) => <DataTypeProvider editorComponent={ConveniosEditor} {...props} />;
